import { cva } from "class-variance-authority";
//#region src/components/RadioGroup/styles.ts
/** The radio's circle: shape and checked state, shared by the form `Radio` and the menu radio. */
const radioCircleVariants = cva([
	"tw:shrink-0",
	"tw:flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:size-4",
	"tw:rounded-full",
	"tw:border",
	"tw:border-solid",
	"tw:border-input",
	"tw:transition-colors",
	"tw:data-[state=checked]:bg-primary",
	"tw:data-[state=checked]:border-primary"
]);
/** The form `Radio`'s button states, layered on `radioCircleVariants`. */
const radioVariants = cva([
	"tw:bg-transparent",
	"tw:p-0",
	"tw:peer",
	"tw:cursor-pointer",
	"tw:whitespace-nowrap",
	"tw:disabled:cursor-not-allowed",
	"tw:disabled:opacity-disabled",
	"tw:data-[state=unchecked]:not-disabled:hover:bg-hover",
	"tw:data-[state=checked]:not-disabled:hover:bg-primary",
	"tw:focus-visible:outline-hidden",
	"tw:focus-visible:border-primary",
	"tw:focus-visible:ring-2",
	"tw:focus-visible:ring-ring/50"
]);
const radioIndicatorVariants = cva([
	"tw:size-2.5",
	"tw:fill-current",
	"tw:text-primary-foreground"
]);
const radioItemButtonVariants = cva([
	"tw:bg-transparent",
	"tw:p-0",
	"tw:peer",
	"tw:cursor-pointer",
	"tw:whitespace-nowrap",
	"tw:flex",
	"tw:items-center",
	"tw:justify-center",
	"tw:disabled:cursor-not-allowed",
	"tw:w-full",
	"tw:px-2",
	"tw:py-1.5",
	"tw:uppercase",
	"tw:font-semibold",
	"tw:font-sans",
	"tw:text-[11px]",
	"tw:whitespace-nowrap",
	"tw:tracking-widest",
	"tw:leading-[18px]",
	"tw:border",
	"tw:border-solid",
	"tw:rounded",
	"tw:disabled:opacity-disabled",
	"tw:text-foreground",
	"tw:border-input",
	"tw:transition-colors",
	"tw:data-[state=unchecked]:bg-muted",
	"tw:data-[state=unchecked]:not-disabled:hover:bg-hover",
	"tw:data-[state=unchecked]:not-disabled:hover:text-hover-foreground",
	"tw:data-[state=checked]:bg-primary",
	"tw:data-[state=checked]:border-primary",
	"tw:data-[state=checked]:text-primary-foreground",
	"tw:data-[state=checked]:not-disabled:cursor-default",
	"tw:focus-visible:outline-hidden",
	"tw:focus-visible:border-primary",
	"tw:focus-visible:ring-2",
	"tw:focus-visible:ring-ring/50"
]);
//#endregion
export { radioCircleVariants, radioIndicatorVariants, radioItemButtonVariants, radioVariants };

//# sourceMappingURL=styles-DxazJ8Mz.js.map